import { render, staticRenderFns } from "./jobCardNew.vue?vue&type=template&id=72ca1ddc&scoped=true"
import script from "./jobCardNew.vue?vue&type=script&lang=js"
export * from "./jobCardNew.vue?vue&type=script&lang=js"
import style0 from "./jobCardNew.vue?vue&type=style&index=0&id=72ca1ddc&prod&scoped=true&lang=scss"
import style1 from "./jobCardNew.vue?vue&type=style&index=1&id=72ca1ddc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ca1ddc",
  null
  
)

export default component.exports